import Text from './_text.js'
import FlexPane from './_flex-pane.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'

export default {
  name: 'EarlyPayoutOffers',
  values: {
    offersText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    offersContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          flexGrow: '1',
          flexShrink: '0',
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
